module.exports = __webpack_public_path__ + "img/18.af50aab1.jpg";